const DOMAINS = ['gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com', 'icloud.com', 'live.com', 'protonmail.com']
const OTHER_DOMAINS = ['mail.com', 'email.com', 'ymail.com', 'googlemail.com', 'hotmail.es', 'outlook.es', 'yahoo.es', 'yahoo.com.ar', 'yahoo.com.br']

// A single insertion, deletion, substitution or adjacent transposition.
function oneEditAway(left, right) {
  if (Math.abs(left.length - right.length) > 1) return false
  let index = 0
  while (index < Math.min(left.length, right.length) && left[index] === right[index]) index++
  if (left.length < right.length) return left.slice(index) === right.slice(index + 1)
  if (left.length > right.length) return left.slice(index + 1) === right.slice(index)
  return left.slice(index + 1) === right.slice(index + 1) ||
    (left[index] === right[index + 1] && left[index + 1] === right[index] && left.slice(index + 2) === right.slice(index + 2))
}

export function suggestEmail(value) {
  const match = value.trim().match(/^([^\s@]+)@([a-z0-9-]+(?:\.[a-z0-9-]+)+)$/i)
  if (!match) return null
  const [, local, rawDomain] = match
  const domain = rawDomain.toLowerCase()
  if (DOMAINS.includes(domain) || OTHER_DOMAINS.includes(domain)) return null
  const candidates = DOMAINS.filter(candidate => oneEditAway(domain, candidate))
  return candidates.length === 1 ? `${local}@${candidates[0]}` : null
}
